import { render, staticRenderFns } from "./TheOrganizationsList.vue?vue&type=template&id=d59498c8&scoped=true"
import script from "./TheOrganizationsList.vue?vue&type=script&lang=js"
export * from "./TheOrganizationsList.vue?vue&type=script&lang=js"
import style0 from "./TheOrganizationsList.vue?vue&type=style&index=0&id=d59498c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d59498c8",
  null
  
)

export default component.exports